module.exports = __webpack_public_path__ + "static/desktop_29-03231f85fe25454146161a907b1b655a.png";